'use client';

import { motion } from 'framer-motion';
import { BriefcaseBusiness } from 'lucide-react';
import React from 'react';
import ClientOrbits from '@/components/ui/ClientOrbits';
import Worked from '@/components/ui/worked';
import SkillsCardSlider from '../ui/SkillsCardSlider';

const WorkSection = () => {
  return (
    <section className="from-card/0 via-background/10 to-background relative overflow-hidden bg-gradient-to-br py-20 md:py-40">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="bg-secondary/0 absolute -top-40 -left-40 h-80 w-80 rounded-full blur-3xl" />
        <div className="bg-accent/5 absolute top-1/2 left-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl" />
      </div>

      <div className="relative container mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-16 text-center"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="bg-primary/10 border-primary/20 mb-6 inline-flex items-center gap-3 rounded-full border px-6 py-3"
          >
            <BriefcaseBusiness className="h-5 w-5 text-blue-500" />
            <span className="text-sm font-medium text-blue-400">Work</span>
          </motion.div>
          <div className="from-foreground via-primary to-foreground mb-2 bg-gradient-to-r bg-clip-text text-4xl leading-tight font-bold text-transparent md:text-5xl lg:text-6xl xl:text-7xl">
            <span className="text-foreground">Professional</span> Experience
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="text-foreground antonio mx-auto max-w-2xl font-serif text-lg leading-relaxed md:max-w-4xl md:text-xl lg:text-2xl"
          >
            I&apos;ve worked on a variety of projects, from small side projects
            to large scale applications.
          </motion.p>
        </motion.div>
        <div className="mb-12 flex items-center justify-center">
          <SkillsCardSlider />
        </div>
        <div className="flex items-center justify-center gap-16">
          <div className="relative flex items-center justify-center">
            <ClientOrbits />
          </div>
          <div className="absolute flex items-center justify-center">
            <Worked />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkSection;
